import {createApp, defineAsyncComponent} from "vue";
import axios from "axios";

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Vue = createApp({});

Vue.component('embed-form-component', defineAsyncComponent(() => {
    return import('./components/embed/EmbedFormComponent.vue');
}));
Vue.component('embed-form-business', defineAsyncComponent(() => {
    return import('./components/embed/EmbedFormBusiness.vue');
}));
Vue.component('validation-error-component', defineAsyncComponent(() => {
    return import('./components/ValidationErrorComponent.vue');
}));

Vue.mount('#app');
